<template>
  <div class="category-wrap" v-on-clickaway="hideCategoryList">
    <el-tabs type="border-card">
      <el-tab-pane v-for="(grant,grantIndex) in categoryList" :label="grant.title" :key="grantIndex">
        <!--有三级子菜单-->
        <div class="three-menu clearfix" 
          v-for="(item,itemIndex) in grant.content" 
          :key="itemIndex"
          v-if="item.content.length">
          <div class="cat-title">{{item.title}}:</div>
          <div class="cat-list">
            <span :class="{'active':categoryStr==grant.title+'-'+item.title+'-'+child}"
              @click="categoryStr=grant.title+'-'+item.title+'-'+child" 
              v-for="(child,childIndex) in item.content"
              :key="childIndex">
                {{child}}
            </span>
          </div>
        </div>
        <!--只有第二级-->
        <span class="two-menu"  :class="{'active':categoryStr==grant.title+'-'+item.title}"
          v-for="(item,index) in grant.content" 
          :key="index"
          v-if="!item.content.length"
          @click="categoryStr=grant.title+'-'+item.title">
            {{item.title}}
        </span>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'CategorySelect',
  props: ['categoryList'],
  mixins: [ clickaway ],
  components: {
    
  },
  data(){
    return {
      categoryStr: '',
    }
  },
  methods: {
    hideCategoryList(){
      this.$emit("hideCategoryList")
    }
  },
  watch:{
    categoryStr(n, o){
      this.$emit("categoryChange",this.categoryStr)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styl/variables'
.category-wrap
  width: 5.25rem
.el-tab-pane
  height: 3rem
  overflow-y: auto 
.three-menu
  border-bottom: 1px dashed color-light-sliver
  padding: .05rem 0
  &:last-child
    border-bottom: none
  .cat-title
    width: .8rem
    font-weight: bold
    color: color-dark-black
    line-height:.28rem
    display:inline-block
    float:left
  .cat-list
    display: inline-block
    width:4.1rem
    float:left
    span
      display: block
      width: .8rem
      text-align: center
      line-height: .28rem
      cursor: pointer
      margin: .01rem
      color: color-main
      float:left
      &:hover,&.active
        background-color: color-sliver
        color: #fff
.two-menu
  display: inline-block
  width: .8rem
  height: .28rem
  line-height:.28rem
  text-align:center
  cursor: pointer
  position:relative
  margin: .05rem .01rem 
  &:after
    content: ''
    display: block
    width: .8rem
    height: 0
    position: absolute
    bottom: -0.05rem
    border-bottom: 1px dashed color-light-sliver
  &:hover,&.active
    background-color: color-sliver
    color: #fff

</style>



// WEBPACK FOOTER //
// app/components/Dashboard/App/Create/CategorySelect.vue